import { render, staticRenderFns } from "./TradeFair.vue?vue&type=template&id=5d023b0d&lang=pug&"
import script from "./TradeFair.vue?vue&type=script&lang=ts&"
export * from "./TradeFair.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports